import type { AgreementContent } from '../api/mediatorService';

/**
 * Render a structured agreement as plain markdown. Used for the in-sidebar
 * preview and for the Copy-as-Markdown action. Kept dumb / deterministic so
 * the mediator can paste the output into Google Docs, Notion, Zoom Docs,
 * etc. without surprises.
 */
export function agreementToMarkdown(c: AgreementContent): string {
  const lines: string[] = [];
  lines.push(`# ${c.title}`);
  lines.push('');
  lines.push(`**Date:** ${c.date}`);
  lines.push('');

  lines.push(`## Parties`);
  for (const p of c.parties) lines.push(`- **${p.name}** — ${p.role}`);
  lines.push('');

  lines.push(`## Agreed Terms`);
  for (const section of c.agreed_terms) {
    lines.push('');
    lines.push(`### ${section.section}`);
    for (const term of section.terms) lines.push(`- ${term}`);
  }
  lines.push('');

  lines.push(`## Signatures Required`);
  for (const p of c.signatures_required) {
    lines.push(`- **${p.name}** — ${p.role}`);
    lines.push('');
    lines.push(`  Signature: _________________________  Date: ____________`);
    lines.push('');
  }

  // The mediator facilitates and does not sign (Danny, 2026-08-05).
  lines.push(`*Mediated by ${c.mediator}.*`);
  lines.push('');

  lines.push(`---`);
  lines.push(c.confidentiality_notice);

  return lines.join('\n');
}
